<div id="reasonCodeDialog" class="modal modal-med modal-dialog fade in" role="dialog" style="display: none;position:absolute !important" 
    appDraggable dragTarget="#reasonCodeDialog" dragHandle="#reasonCodeDialogHeader" data-backdrop="static" data-keyboard="false">
  <div class="modal-content">

    <!-- Header -->
    <div class="modal-header" id="reasonCodeDialogHeader">
      <button type="button" class="close" (click)="hide()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <h4 class="modal-title">Set Reason Code / Comment</h4>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <div class="row">
        <div class="form-group">
          <div class="col-sm-4">
            <label class="labelRequired">Reason Code: </label>
          </div>
          <div class="col-sm-8">
            <select class="form-control" [(ngModel)]="selectedReasonCodeUi" (ngModelChange)="onReasonCodeChanged()">
                <option [ngValue]="undefined"> -- Choose Reason Code -- </option>
                <option *ngFor="let reasonCode of availableReasonCodeOptions; index as i" [ngValue]="reasonCode">{{ reasonCode.reason_code }} - {{ reasonCode.description }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedReasonCodeUi?.allows_comments">
        <div class="form-group">
          <div class="col-sm-4">
            <label class="labelNormal">Comment</label>
          </div>
          <div class="col-sm-8">
            <textarea rows="4" cols="40" class="form-control" [(ngModel)]="commentUi"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" (click)="onCancelClicked()" class="btn btn-default">
        <i class="fa fa-ban" aria-hidden="true"></i> CANCEL
      </button>
      <button type="button" (click)="onSetClicked()" class="btn btn-primary">
        <i class="fa fa-refresh" aria-hidden="true"></i> SET
      </button>
    </div>
  </div>
</div>